<template>
  <SameAthlete v-if="isSameAthlete" ref="AthleteAcademicSameAthleteEmptyState" />
  <Default v-else ref="AthleteAcademicDefaultEmptyState" />
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters } from "vuex";
import SameAthlete from "./AthleteAcademicSameAthleteEmptyState.vue";
import Default from "./AthleteAcademicDefaultEmptyState.vue";

export default defineComponent({
  name: "AthleteAcademicEmptyState",
  components: { Default, SameAthlete },
  computed: {
    ...mapGetters("athleteProfile", ["isSameAthlete"]),
  },
})
</script>